import request from '@/api/base'

const getCustomMenuList = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    params.mockApi = false
    return request.post('/customMenu/list', params)
  } else {
    return request.post('/dcits-consumption/customMenu/list', params)
  }
}
const updateCustomMenu = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    params.mockApi = false
    return request.post('/customMenu/update', params)
  } else {
    return request.post('/dcits-consumption/customMenu/update', params)
  }
}

const saveBatchCustomMenu = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    params.mockApi = false
    return request.post('/customMenuUser/saveBatch', params)
  } else {
    return request.post('/dcits-consumption/customMenuUser/saveBatch', params)
  }
}

const getUserCustomMenu = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    params.mockApi = false
    return request.post('/customMenuUser/getUserCustomMenu', params)
  } else {
    return request.post('/dcits-consumption/customMenuUser/getUserCustomMenu', params)
  }
}

export default {
  getCustomMenuList,
  saveBatchCustomMenu,
  updateCustomMenu,
  getUserCustomMenu
}



// WEBPACK FOOTER //
// ./src/area-contract/api/customMenu.js